import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../api';
import { DEFAULT_PUBLIC_BRAND, resolvePublicBrand } from '../utils/publicBrand';

/**
 * Load tenant brand for public pages. Pass `embedded` from parent API response to skip fetch.
 */
export default function usePublicBrand(embedded) {
  const [brand, setBrand] = useState(() => resolvePublicBrand(embedded));
  const [loading, setLoading] = useState(!embedded);

  useEffect(() => {
    if (embedded) {
      setBrand(resolvePublicBrand(embedded));
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE_URL}public/brand`, { headers: { Accept: 'application/json' } });
        const json = await res.json().catch(() => ({}));
        if (!cancelled) {
          setBrand(res.ok ? resolvePublicBrand(json.data) : resolvePublicBrand(DEFAULT_PUBLIC_BRAND));
        }
      } catch {
        if (!cancelled) setBrand(resolvePublicBrand(DEFAULT_PUBLIC_BRAND));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [embedded]);

  return { brand, loading };
}
